import type { HorseStatistic, PlayerStatistic } from '~/app';

export type ResultsMockScenarioId = 'default' | 'long-names' | 'close-finish';

export type ResultsMockData = {
  horses: HorseStatistic[];
  players: PlayerStatistic[];
};

/** `rank` / `totalRank` are 0-based like live game state; bars show `totalRank + 1` as "Platz". */
const mockScenarios: Record<ResultsMockScenarioId, ResultsMockData> = {
  default: {
    players: [
      { index: 0, name: 'Flo', points: [12, 10, 8], pointsSum: 30, totalRank: 0 },
      { index: 1, name: 'Micha', points: [10, 9, 7], pointsSum: 26, totalRank: 1 },
      { index: 2, name: 'Andi', points: [8, 7, 6], pointsSum: 21, totalRank: 2 },
      { index: 3, name: 'Sarah', points: [7, 6, 5], pointsSum: 18, totalRank: 3 },
    ],
    horses: [
      {
        userId: '0x1',
        playerName: 'Flo',
        name: 'Stormrunner',
        color: 3,
        jockeyName: 'Jockey Flo',
        points: [5, 4, 3],
        pointsSum: 12,
        rank: 0,
        totalRank: 0,
        turnPos: 0,
        country: 'de',
      },
      {
        userId: '0x2',
        playerName: 'Micha',
        name: 'Midnight Arrow',
        color: 7,
        jockeyName: 'Jockey Micha',
        points: [4, 3, 3],
        pointsSum: 10,
        rank: 1,
        totalRank: 1,
        turnPos: 1,
        country: 'de',
      },
      {
        userId: '0x3',
        playerName: 'Andi',
        name: 'Copper Comet',
        color: 2,
        jockeyName: 'Jockey Andi',
        points: [3, 3, 2],
        pointsSum: 8,
        rank: 2,
        totalRank: 2,
        turnPos: 2,
        country: 'at',
      },
      {
        userId: '0x4',
        playerName: 'Sarah',
        name: 'Velvet Thunder',
        color: 0,
        jockeyName: 'Jockey Sarah',
        points: [2, 3, 2],
        pointsSum: 7,
        rank: 3,
        totalRank: 3,
        turnPos: 3,
        country: 'ch',
      },
      {
        userId: '0x5',
        playerName: 'Flo',
        name: 'Green Lantern',
        color: 1,
        jockeyName: 'Jockey Flo',
        points: [4, 3, 1],
        pointsSum: 8,
        rank: 4,
        totalRank: 4,
        turnPos: 4,
        country: 'de',
      },
      {
        userId: '0x6',
        playerName: 'Micha',
        name: 'Silver Lining',
        color: 4,
        jockeyName: 'Jockey Micha',
        points: [3, 2, 2],
        pointsSum: 7,
        rank: 5,
        totalRank: 5,
        turnPos: 5,
        country: 'de',
      },
      {
        userId: '0x7',
        playerName: 'Andi',
        name: 'Saffron Skies',
        color: 6,
        jockeyName: 'Jockey Andi',
        points: [2, 2, 1],
        pointsSum: 5,
        rank: 6,
        totalRank: 6,
        turnPos: 6,
        country: 'at',
      },
      {
        userId: '0x8',
        playerName: 'Sarah',
        name: 'Last Chance',
        color: 5,
        jockeyName: 'Jockey Sarah',
        points: [1, 2, 1],
        pointsSum: 4,
        rank: 7,
        totalRank: 7,
        turnPos: 7,
        country: 'ch',
      },
    ],
  },
  'long-names': {
    players: [
      { index: 0, name: 'Michaasfdasfdasfd', points: [9, 9, 9], pointsSum: 27, totalRank: 0 },
      {
        index: 1,
        name: 'Flo (very very long stable name)',
        points: [8, 8, 7],
        pointsSum: 23,
        totalRank: 1,
      },
      { index: 2, name: 'Andi', points: [7, 7, 7], pointsSum: 21, totalRank: 2 },
      { index: 3, name: 'Sarah', points: [6, 6, 6], pointsSum: 18, totalRank: 3 },
    ],
    horses: [
      {
        userId: '0x1',
        playerName: 'Michaasfdasfdasfd',
        name: 'The Unreasonably Long Horse Name That Tests Wrapping',
        color: 4,
        jockeyName: 'Jockey Michaasfdasfdasfd',
        points: [4, 3, 2],
        pointsSum: 9,
        rank: 0,
        totalRank: 0,
        turnPos: 0,
        country: 'de',
      },
      {
        userId: '0x2',
        playerName: 'Flo (very very long stable name)',
        name: 'Sir Gallops-a-Lot the Third',
        color: 3,
        jockeyName: 'Jockey Flo (very very long stable name)',
        points: [3, 3, 2],
        pointsSum: 8,
        rank: 1,
        totalRank: 1,
        turnPos: 1,
        country: 'de',
      },
      {
        userId: '0x3',
        playerName: 'Andi',
        name: 'Short',
        color: 7,
        jockeyName: 'Jockey Andi',
        points: [2, 3, 2],
        pointsSum: 7,
        rank: 2,
        totalRank: 2,
        turnPos: 2,
        country: 'at',
      },
      {
        userId: '0x4',
        playerName: 'Sarah',
        name: 'Name-With-Dashes-And_underscores',
        color: 2,
        jockeyName: 'Jockey Sarah',
        points: [2, 2, 2],
        pointsSum: 6,
        rank: 3,
        totalRank: 3,
        turnPos: 3,
        country: 'ch',
      },
    ],
  },
  'close-finish': {
    players: [
      { index: 0, name: 'Flo', points: [9, 8, 9], pointsSum: 26, totalRank: 0 },
      { index: 1, name: 'Micha', points: [8, 9, 8], pointsSum: 25, totalRank: 1 },
      { index: 2, name: 'Andi', points: [8, 8, 8], pointsSum: 24, totalRank: 2 },
      { index: 3, name: 'Sarah', points: [7, 8, 8], pointsSum: 23, totalRank: 3 },
    ],
    horses: [
      {
        userId: '0x1',
        playerName: 'Flo',
        name: 'Photo Finish',
        color: 3,
        jockeyName: 'Jockey Flo',
        points: [3, 3, 3],
        pointsSum: 9,
        rank: 0,
        totalRank: 0,
        turnPos: 0,
        country: 'de',
      },
      {
        userId: '0x2',
        playerName: 'Micha',
        name: 'Neck and Neck',
        color: 4,
        jockeyName: 'Jockey Micha',
        points: [3, 3, 2],
        pointsSum: 8,
        rank: 1,
        totalRank: 1,
        turnPos: 1,
        country: 'de',
      },
      {
        userId: '0x3',
        playerName: 'Andi',
        name: 'Final Sprint',
        color: 7,
        jockeyName: 'Jockey Andi',
        points: [3, 2, 3],
        pointsSum: 8,
        rank: 2,
        totalRank: 2,
        turnPos: 2,
        country: 'at',
      },
      {
        userId: '0x4',
        playerName: 'Sarah',
        name: 'Last Meter',
        color: 2,
        jockeyName: 'Jockey Sarah',
        points: [2, 3, 2],
        pointsSum: 7,
        rank: 3,
        totalRank: 3,
        turnPos: 3,
        country: 'ch',
      },
    ],
  },
};

export const resultsMockScenarioIds = Object.keys(mockScenarios) as ResultsMockScenarioId[];

export function getResultsMockData(scenario?: string): ResultsMockData {
  const resolvedScenario =
    scenario && scenario in mockScenarios ? (scenario as ResultsMockScenarioId) : 'default';
  return mockScenarios[resolvedScenario];
}

// Backward compatible name used by selectors fallback behavior (no-horses state).
export const debugHorseData: HorseStatistic[] = mockScenarios.default.horses;
